export default __webpack_public_path__ + "static/media/openedArrow.81192b69.svg";